import { ChevronRight } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';
import NextStepButton from '../../../Components/NextStepButton';
import { StepperNavigationButtons } from '../../../Components/StepperNavigationButtons';
import StepProps from '../../StepProps';
import { JobDetailsFormValues, getErrorFieldNames } from '../JobDetailsStepUtils';

interface JobDetailsStepNavigationProps extends StepProps {
    processingState: ProcessingState;
}

function JobDetailsStepNavigation({
    activeStep,
    handleBack,
    processingState,
}: JobDetailsStepNavigationProps): React.JSX.Element {
    const [nextButtonDisabled, setNextButtonDisabled] = useState(false);
    const values = useWatch();

    useEffect(() => {
        const fieldNames = getErrorFieldNames(values as JobDetailsFormValues);
        setNextButtonDisabled(fieldNames.length > 0);
    }, [values]);

    return (
        <StepperNavigationButtons
            activeStep={activeStep}
            handleBack={handleBack}
            nextButtonComponent={
                <NextStepButton
                    disabled={nextButtonDisabled}
                    loading={processingState === ProcessingState.Processing}
                    endIcon={<ChevronRight className="size-4" aria-hidden />}
                >
                    {UIStrings.Next}
                </NextStepButton>
            }
            processingState={processingState}
        />
    );
}

export default JobDetailsStepNavigation;
